import { render } from "./PageBuilder.vue?vue&type=template&id=7554fe43"
import script from "./PageBuilder.vue?vue&type=script&lang=js"
export * from "./PageBuilder.vue?vue&type=script&lang=js"

import "./PageBuilder.vue?vue&type=style&index=0&id=7554fe43&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__